import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { runningInBrowser } from "~/const/browser";
import { COOKIE } from "~/const/cookie";
import { PATHS } from "~/const/paths";
import { useQueryString } from "~/hooks/use-query-string";
import { getCookie } from "~/util/get-cookie";

export const useShowGlobalNaviAndFooter = () => {
  const { asPath, isReady } = useRouter();
  const { contentonly } = useQueryString();

  const [isShowGlobalNaviAndFooter, setIsShowGlobalNavAndFooter] = useState(true);

  const isPlayback = asPath.startsWith(PATHS.VOD_PLAYER);
  const isMaintenance = asPath.startsWith(PATHS.MAINTENANCE);

  /** cookieにhas-contentonlyがsetされているかの判定フラグ */
  const hasContentOnlyInCookie = runningInBrowser ? getCookie(COOKIE.HAS_CONTENT_ONLY.KEY) : undefined;

  useEffect(() => {
    if (!isReady) return;
    /** 1. player画面時global nav & footerを非表示にする */
    isShowGlobalNaviAndFooter && isPlayback ? setIsShowGlobalNavAndFooter(false) : setIsShowGlobalNavAndFooter(true);

    /**
     * 2. queryにcontentonlyが付与されている場合
     * - global nav & footerを非表示にする
     * - ブラウザ終了時までcookieにhas_content_only=trueをセット
     */
    if (contentonly !== undefined) {
      setIsShowGlobalNavAndFooter(false);
      if (hasContentOnlyInCookie === undefined)
        document.cookie = `${COOKIE.HAS_CONTENT_ONLY.KEY}=${COOKIE.HAS_CONTENT_ONLY.VALUE}`;
      return;
    }

    /** 3. cookieにcontentonlyがsetされている場合 global nav & footerを非表示にする */
    if (hasContentOnlyInCookie !== undefined) setIsShowGlobalNavAndFooter(false);

    /** 4. メンテナンス画面時global nav & footerを非表示にする */
    if (isShowGlobalNaviAndFooter && isMaintenance) setIsShowGlobalNavAndFooter(false);

    return () => {
      setIsShowGlobalNavAndFooter(true);
    };
  }, [isPlayback, contentonly, hasContentOnlyInCookie, isReady, isMaintenance]);

  return {
    isShowGlobalNaviAndFooter,
  };
};
